import { Checkbox, InputNumber, Popover } from "antd";
import React, { useState, useEffect, useContext } from "react";
import AddToCart from "../../components/AddToCart/AddToCart";
import PopupNotes from "../../components/PopupNotes/PopupNotes";
import SmallModal from "../../components/SmallModal/SmallModal";
import { AppContext } from "../../context";
import { truncate } from "../../library/text";
import { addVehicleToCart } from "./addVehicleToCart";
import ChargingTime from "./components/ChargingTime";
import Range from "./components/Range";
import ExtraList from "./ExtraList";
import ExtraSelection from "./ExtraSelection";
import RentacarReservationInfo from "./RentacarReservationInfo";
import { GrCircleInformation } from "react-icons/gr";
import { GiStopSign } from "react-icons/gi";
import Conditions from "./components/Conditions";
import CurrentReservations from "./components/CurrentReservations";
import DriverInfo from "./components/DriverInfo";

function RentacarCardContent({
  product,
  context,
  setIsAddedToCartVisible,
  setAddedToCart,
  clientRequest,
}) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const [extraReservationConfig, setExtraReservationConfig] = useState([]);
  const [driverInfo, setDriverInfo] = useState({
    name: "",
    address: "",
    phone: "",
    idCard: "",
    driverLicense: "",
    nif: "",
    privacy: false,
    terms: false,
  });
  const [driverInfoFilled, setDriverInfoFilled] = useState(false);
  const info = useContext(AppContext);
  const [showAgeInput, setShowAgeInput] = useState(true);
  const [age, setAge] = useState(null);

  console.log("re-rendered RentacarCardContent");

  const setDriverInfoFn = (value) => {
    setDriverInfo({ ...driverInfo, ...value });
  };

  // useEffect(() => {
  //   if (driverInfoFilled === true)
  // scroll modal - the following code scrolls the window, not the modal
  //     window.scrollTo(0, document.body.scrollHeight);
  // }, [driverInfoFilled]);

  const selectComponent = () => {
    switch (context) {
      // undefined - content of the car card in the car grid
      case undefined:
        return (
          <>
            <div className="card-body">
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                {product?.gen_features?.charging_time && (
                  <ChargingTime
                    chargingTime={product?.gen_features?.charging_time}
                  />
                )}

                {product?.gen_features?.range && (
                  <Range range={product?.gen_features?.range} />
                )}
              </div>
              {product?.reservation_time_ranges?.some(
                (el) => el.startDateTime !== ""
              ) && (
                <CurrentReservations
                  reservation_time_ranges={product.reservation_time_ranges}
                />
              )}
              <div className="short-description">
                {truncate(
                  product?.gen_description && product?.gen_description["pt"],
                  160,
                  true
                )}
              </div>
            </div>
          </>
        );
      case "reservation-info":
        return (
          <div className="ahp-reservation-content">
            <hr style={{ width: "80%", marginTop: 30, marginBottom: 20 }} />

            <div
              className="ahp-reservation-typology"
              style={{ marginTop: 10, marginBottom: 10 }}
            >
              {info.t("reservingAs")}{" "}
              <strong>{info.t(info.rentacar?.typology)} </strong>
              {product.ren_profile_conditions?.[info.rentacar?.typology]?.[
                info.language
              ]?.length > 0 && (
                <Popover
                  content={
                    <div style={{ padding: 10 }}>
                      {
                        product.ren_profile_conditions[info.rentacar.typology][
                          info.language
                        ]
                      }
                    </div>
                  }
                >
                  -{" "}
                  <span style={{ color: "blue" }}>
                    {info.t("readConditions")}
                  </span>{" "}
                  <GrCircleInformation color="blue" />
                </Popover>
              )}
              {/* for X days */}
              <br />
              {info.t("reserveFor")} <strong>{info.rentacar.days} </strong>
              {info.t("days").toLowerCase()}
            </div>

            <RentacarReservationInfo product={product} />

            <hr style={{ width: "80%", marginTop: 20, marginBottom: 20 }} />

            <ExtraSelection
              product={product}
              extraReservationConfig={extraReservationConfig}
              setExtraReservationConfig={setExtraReservationConfig}
            />

            <hr style={{ width: "80%", marginTop: 20, marginBottom: 20 }} />

            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <Checkbox onChange={() => setShowAgeInput(!showAgeInput)}>
                {info.t("driverAgeRange")}
              </Checkbox> */}

              {showAgeInput && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ marginRight: 10 }}>{info.t("driversAge")}</div>
                  <InputNumber
                    min={1}
                    max={100}
                    size="small"
                    style={{ width: 55 }}
                    // defaultValue={3}
                    autoFocus
                    onChange={(age) => {
                      setAge(age);
                      console.log("onChange");
                    }}
                  />
                </div>
              )}
            </div>

            {showAgeInput && age < product.gen_features.minimum_age && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 10,
                  backgroundColor: "red",
                  color: "white",
                  width: "100%",
                  textAlign: "center",
                  padding: 10,
                }}
              >
                <GiStopSign color="white" size={30} />
                <div style={{ marginLeft: 10 }}>
                  {info.t("ageDoesntAllowReservation")}
                </div>
              </div>
            )}
            {(!showAgeInput || age >= product.gen_features.minimum_age) && (
              <div>
                {/* client info */}
                <DriverInfo
                  setDriverInfoFn={setDriverInfoFn}
                  setDriverInfoFilled={setDriverInfoFilled}
                />

                {driverInfo.name.length > 0 &&
                  driverInfo.privacy &&
                  driverInfo.terms && (
                    <AddToCart
                      setIsAddedToCartVisible={setIsAddedToCartVisible}
                      handleAddToCart={() =>
                        addVehicleToCart(
                          product,
                          info,
                          extraReservationConfig,
                          clientRequest,
                          setAddedToCart,
                          driverInfo
                        )
                      }
                    />
                  )}
              </div>
            )}
          </div>
        );
      case "cart":
        return (
          <div className="ahp-reservation-content">
            <RentacarReservationInfo product={product} />

            {product.extras.length > 0 && (
              <ExtraList extraList={product.extras} />
            )}

            <PopupNotes notes={product.request} />

            {/* <div style={{ margin: 20 }}>
              <Conditions
                conditions={product?.ren_conditions}
                typology={product?.ren_typology}
              />
            </div> */}
          </div>
        );
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <div className="ahp-reservation-content">
            <RentacarReservationInfo product={product} />

            <ExtraList extraList={product.extras} />
            <PopupNotes notes={product.request} />
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div>
      {context !== "ticket" &&
      context !== "reservation-info" &&
      context !== "payment" &&
      !(
        product?.status === "not-available" || product?.status === "not-defined"
      ) &&
      (product.gen_price || product.total_price) ? (
        <div className="ahp-price">
          <div className="ahp-price-value">
            {product.total_price || product?.gen_price} €
          </div>
          {/* <div
            className="ahp-price-info"
            onClick={() => setIsPriceModalVisible(true)}
          >
            i
          </div> */}
        </div>
      ) : (
        ""
      )}
      {selectComponent()}
      <SmallModal
        // text="Preço por dia."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
        width="200px"
      />
    </div>
  );
}

export default RentacarCardContent;
